/**
 * Checks if the current worksheet is being rendered as part of report (dashboard views positioning)
 */
export function isWorksheetReportPrinting() {
  const workbookPage = document.querySelector<HTMLElement>('.d-workbook-page');
  return workbookPage?.classList.contains('is-report-printing');
}

export function setIsWorksheetReportPrinting() {
  const workbookPage = document.querySelector<HTMLElement>('.d-workbook-page');
  workbookPage?.classList.add('is-report-printing');
}
